import type { paths } from "@/lib/api.d";
import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import { env } from "@env";

const fetchClient = createFetchClient<paths>({
  baseUrl: env.VITE_API_BASE_URL,
  credentials: "include",
});

export const api = createClient(fetchClient);
